import React, { Component } from "react";
import StructureFases from "../../components/structure/StructureFases";
import CircularProgress from "@material-ui/core/CircularProgress";
import NoStructureMessage from "../../components/structure/NoStructureMessage";
import { languages } from "../../constants/languages";
import UpgradeDialog from "../../components/UpgradeDialog";

class StructureFasesContainer extends Component {
  state = {
    // teams: [],
    // teamsLoaded: false,
    resultSpotsAll: [],
    resultSpotsLoaded: false,
    poules: [],
    poulesByKey: {},
    poulesLoaded: false,
    allBrackets: [],
    brackets: [],
    subBrackets: {},
    bracketsByKey: {},
    bracketsLoaded: false,
    daysByKey: {},
    daysLoaded: false,
    oneSecondPassed: false,
    upgradeDialogOpen: false,
    upgradeDialogStructurePage: true,
  };

  toggleUpgradeDialog = (structurePage = true) => {
    if (!this.state.upgradeDialogOpen) {
      // mailer lite paywall seen
      window.firebase
        .firestore()
        .collection("paywallSeenRequests")
        .doc()
        .set({ uid: this.props.user.uid });
    }
    this.setState({
      upgradeDialogOpen: !this.state.upgradeDialogOpen,
      upgradeDialogStructurePage: structurePage,
    });
  };

  UNSAFE_componentWillMount = () => {
    this.timeout = setTimeout(() => {
      this.setState({ oneSecondPassed: true });
    }, 1000);
    // this.unsubscribe = window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("teams")
    //   .where("division", "==", this.props.division.id)
    //   .onSnapshot(querySnapshot => {
    //     var teams = [];
    //     querySnapshot.forEach(doc => {
    //       let team = doc.data();
    //       team["id"] = doc.id;
    //       teams.push(team);
    //     });
    //     teams.sort((a, b) => {
    //       return a.name > b.name;
    //     });
    //     this.setState({ teams: teams, teamsLoaded: true });
    //   });

    this.unsubscribe2 = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots")
      .where("division", "==", this.props.division.id)
      .onSnapshot((querySnapshot) => {
        let resultSpotsAll = [];
        querySnapshot.forEach((doc) => {
          let resultSpot = doc.data();
          resultSpot["id"] = doc.id;
          resultSpot["resultSpot"] = true;
          resultSpotsAll.push(resultSpot);
        });
        this.setState({
          resultSpotsAll: resultSpotsAll,
          resultSpotsLoaded: true,
        });
      });

    this.unsubscribe3 = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules")
      .where("division", "==", this.props.division.id)
      .onSnapshot((querySnapshot) => {
        let poules = [];
        let poulesByKey = {};
        querySnapshot.forEach(function (doc) {
          let poule = doc.data();
          poule["id"] = doc.id;
          poules.push(poule);
          poulesByKey[doc.id] = doc.data();
        });
        poules.sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        });
        this.setState({
          poules: poules,
          poulesByKey: poulesByKey,
          poulesLoaded: true,
        });
      });

    this.unsubscribe4 = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets")
      .where("division", "==", this.props.division.id)
      .onSnapshot((querySnapshot) => {
        let allBrackets = [];
        let brackets = [];
        let subBrackets = {};
        let bracketsByKey = {};
        querySnapshot.forEach(function (doc) {
          let bracket = doc.data();
          bracket["id"] = doc.id;
          if (bracket.subBracketTo) {
            if (subBrackets[bracket.subBracketTo] === undefined) {
              subBrackets[bracket.subBracketTo] = [];
            }
            subBrackets[bracket.subBracketTo].push(bracket);
          } else {
            brackets.push(bracket);
          }
          bracketsByKey[doc.id] = bracket;
          allBrackets.push(bracket);
        });
        brackets.sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        });
        this.setState({
          allBrackets: allBrackets,
          brackets: brackets,
          subBrackets: subBrackets,
          bracketsByKey: bracketsByKey,
          bracketsLoaded: true,
        });
      });

    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    // unsubscribe
    // this.unsubscribe();
    this.unsubscribe2();
    this.unsubscribe3();
    this.unsubscribe4();
    this.unsubscribeDays();
    clearTimeout(this.timeout);
  };

  render() {
    let resultSpotsNotDivided = this.state.resultSpotsAll.filter((rs) => {
      for (let i in this.props.division.fases || [true]) {
        if (this.state.poulesByKey[rs["poule" + i]]) {
          return false;
        }
      }
      return true;
    });
    let teamsNotDivided = this.props.teams
      .filter((team) => {
        for (let i in this.props.division.fases || [true]) {
          if (this.state.poulesByKey[team["poule" + i]]) {
            return false;
          }
        }
        return true;
      })
      .sort((a, b) => {
        function chunkify(t) {
          var tz = [],
            x = 0,
            y = -1,
            n = 0,
            i,
            j;

          while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
            // eslint-disable-next-line
            var m = i == 46 || (i >= 48 && i <= 57);
            if (m !== n) {
              tz[++y] = "";
              n = m;
            }
            tz[y] += j;
          }
          return tz;
        }

        let toChunkA = a["name"] || "";
        let toChunkB = b["name"] || "";

        var aa = chunkify(toChunkA.toString().toLowerCase());
        var bb = chunkify(toChunkB.toString().toLowerCase());

        for (let x = 0; aa[x] && bb[x]; x++) {
          if (aa[x] !== bb[x]) {
            var c = Number(aa[x]),
              d = Number(bb[x]);
            // eslint-disable-next-line
            if (c == aa[x] && d == bb[x]) {
              return c - d;
            } else return aa[x] > bb[x] ? 1 : -1;
          }
        }
        return aa.length - bb.length;
      });

    let resultSpots = resultSpotsNotDivided.sort((a, b) => {
      if (a.rank > b.rank) {
        return 1;
      } else if (a.rank < b.rank) {
        return -1;
      } else if (
        (this.state.poulesByKey[a.fromPoule] || {}).indexNum >
        (this.state.poulesByKey[b.fromPoule] || {}).indexNum
      ) {
        return 1;
      } else if (
        (this.state.poulesByKey[a.fromPoule] || {}).indexNum <
        (this.state.poulesByKey[b.fromPoule] || {}).indexNum
      ) {
        return -1;
      } else {
        return (
          (this.state.poulesByKey[a.fromPoule] || {}).num -
          (this.state.poulesByKey[b.fromPoule] || {}).num
        );
      }
    });
    return this.state.poulesLoaded &&
      this.state.bracketsLoaded &&
      this.state.resultSpotsLoaded &&
      this.state.daysLoaded &&
      this.props.teamsLoaded ? (
      <div>
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          structurePage={this.state.upgradeDialogStructurePage}
          maxTeams={this.props.maxTeams}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
        {Object.keys(this.state.poulesByKey).length === 0 &&
        Object.keys(this.state.bracketsByKey).length === 0 ? (
          <NoStructureMessage
            tournament={this.props.tournament}
            divisions={this.props.divisions}
            division={this.props.division}
            poules={this.state.poules.filter((poule) => poule.fase === 0)}
            fase={0}
            poulesByKey={this.state.poulesByKey}
            bracketsByKey={this.state.bracketsByKey}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.props.toggleFinishedDialog}
            user={this.props.user}
            toggleUpgradeDialog={this.toggleUpgradeDialog}
          />
        ) : (
          <StructureFases
            tournament={this.props.tournament}
            divisionsObject={this.props.divisionsObject}
            division={this.props.division}
            teams={this.props.teams}
            teamsNotDivided={teamsNotDivided}
            resultSpotsNotDivided={resultSpots}
            resultSpotsAll={this.state.resultSpotsAll}
            poules={this.state.poules}
            poulesByKey={this.state.poulesByKey}
            allBrackets={this.state.allBrackets}
            brackets={this.state.brackets}
            subBrackets={this.state.subBrackets}
            bracketsByKey={this.state.bracketsByKey}
            numDivided={this.props.numDivided}
            maxTeams={this.props.maxTeams}
            user={this.props.user}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.props.toggleFinishedDialog}
            userData={this.props.userData}
            daysByKey={this.state.daysByKey}
            toggleUpgradeDialog={this.toggleUpgradeDialog}
          />
        )}
      </div>
    ) : (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          paddingTop: 50,
          height: 190,
        }}
      >
        {this.state.oneSecondPassed && <CircularProgress />}
      </div>
    );
  }
}

export default StructureFasesContainer;
